import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { OptimisticMessage } from '@cosmos/angular/utils';

@Component({
  selector: 'cosmos-message-bubble',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, TranslatePipe],
  templateUrl: './message-bubble.component.html',
})
export class MessageBubbleComponent {
  readonly message = input.required<OptimisticMessage>();
  readonly retry = output<string>();

  protected readonly isCustomer = computed(
    () => this.message().author_type === 'customer',
  );
  protected readonly isAi = computed(() => this.message().author_type === 'AI');

  /** Splits content into plain segments and URL segments for safe linking. */
  protected readonly parts = computed<Array<{ text: string; href?: string }>>(
    () => {
      const text = this.message().content ?? '';
      const urlRe = /(https?:\/\/[^\s]+)/g;
      const out: Array<{ text: string; href?: string }> = [];
      let last = 0;
      let m: RegExpExecArray | null;
      while ((m = urlRe.exec(text))) {
        if (m.index > last) out.push({ text: text.slice(last, m.index) });
        out.push({ text: m[0], href: m[0] });
        last = m.index + m[0].length;
      }
      if (last < text.length) out.push({ text: text.slice(last) });
      return out;
    },
  );
}
